/* eslint-disable @typescript-eslint/naming-convention */

import { styled } from '@mui/material/styles';
import { TextField } from '@mui/material';
import theme from '../../../theme';

// TextFieldのスタイル
export const StyledTextField = styled(TextField)({
	'& label.Mui-focused': {
		color: theme.palette.primary.main,
	},
	'& .MuiInputBase-input': {
		color: theme.palette.common.black, // 入力文字の色
	},
	'& label': {
		color: theme.palette.common.black, // 通常時のラベル色
	},
	'& .MuiOutlinedInput-root': {
		'& fieldset': {
			borderColor: theme.palette.common.black,
		},
		'&:hover fieldset': {
			borderColor: theme.palette.primary.main,
		},
		'&.Mui-focused fieldset': {
			borderColor: theme.palette.primary.main,
		},
	},
});
